import Phaser from 'phaser';
import { SceneKeys } from '../game/Constants';
import { AssetRegistry } from '../systems/AssetRegistry';
import { AudioManager } from '../systems/AudioManager';
import { SaveManager } from '../systems/SaveManager';
import { TutorialManager } from '../systems/TutorialManager';
import { VisualTheme } from '../ui/VisualTheme';
import { createTextButton } from '../ui/components/UIButton';
import { drawPanel } from '../ui/components/SceneChrome';

export class TitleScene extends Phaser.Scene {
  constructor() {
    super(SceneKeys.Title);
  }

  create() {
    const { width, height } = this.scale;
    AudioManager.instance.playMusic(this, 'menu_main');

    const background = AssetRegistry.instance.image('title_screen', 'fallback.title');
    this.add.image(width / 2, height / 2, this.textures.exists(background) ? background : 'fallback.title')
      .setDisplaySize(width, height);
    this.add.rectangle(width / 2, height / 2, width, height, VisualTheme.colors.ink, 0.3);
    this.add.rectangle(width / 2, height - 92, width, 184, VisualTheme.colors.ink, 0.26);

    drawPanel(this, width / 2, height / 2 + 20, 720, 610);
    this.add.rectangle(width / 2, height / 2 - 188, 540, 1, VisualTheme.colors.goldBright, 0.42);
    this.add.text(width / 2, height / 2 - 244, 'CONQUEST OF JAVA', {
      fontFamily: VisualTheme.fonts.display,
      fontSize: '58px',
      color: VisualTheme.text.title,
      stroke: '#1b0f08',
      strokeThickness: 6,
      shadow: { offsetX: 0, offsetY: 5, color: '#000000', blur: 8, fill: true },
    }).setOrigin(0.5);
    this.add.text(width / 2, height / 2 - 172, 'Grand Strategy  •  Dynasty  •  Tactical RTS', {
      fontFamily: VisualTheme.fonts.display,
      fontSize: '21px',
      color: VisualTheme.text.accent,
      letterSpacing: 1,
    }).setOrigin(0.5);

    createTextButton(this, { label: 'New Campaign', x: width / 2, y: height / 2 - 88, width: 320, onClick: () => this.scene.start(SceneKeys.MainMenu) });
    createTextButton(this, { label: SaveManager.instance.hasSave() ? 'Load Autosave' : 'No Autosave Yet', x: width / 2, y: height / 2 - 18, width: 320, onClick: () => this.scene.start(SceneKeys.SaveLoad) });
    createTextButton(this, { label: 'Guided Tutorial', x: width / 2, y: height / 2 + 52, width: 320, onClick: () => {
      TutorialManager.instance.reset();
      this.scene.pause();
      this.scene.launch(SceneKeys.Tutorial, { returnScene: SceneKeys.Title });
    } });
    createTextButton(this, { label: 'Settings & Accessibility', x: width / 2, y: height / 2 + 122, width: 320, onClick: () => {
      this.scene.pause();
      this.scene.launch(SceneKeys.Settings, { returnScene: SceneKeys.Title });
    } });
    createTextButton(this, { label: 'Asset / Build Notes', x: width / 2, y: height / 2 + 192, width: 320, onClick: () => this.scene.start(SceneKeys.SaveLoad, { notes: true }) });

    this.add.text(width / 2, height - 42, 'Tab / controller navigates  •  F1 opens guide  •  F10 opens settings  •  F toggles fullscreen', {
      fontFamily: VisualTheme.fonts.body,
      fontSize: '15px',
      color: VisualTheme.text.body,
      stroke: '#000000',
      strokeThickness: 2,
    }).setOrigin(0.5);

    this.input.keyboard?.on('keydown-F', () => {
      if (this.scale.isFullscreen) this.scale.stopFullscreen();
      else this.scale.startFullscreen();
    });

    const exposed = window as unknown as { render_game_to_text?: () => string; advanceTime?: (ms: number) => void };
    exposed.render_game_to_text = () => JSON.stringify({ mode: 'title', hasAutosave: SaveManager.instance.hasSave(), guideAvailable: true, settingsAvailable: true });
    exposed.advanceTime = () => undefined;
  }
}
